import { render, staticRenderFns } from "./PlusDisplayLayer.vue?vue&type=template&id=2bad5407&name=plus-display-layer&"
import script from "./PlusDisplayLayer.vue?vue&type=script&lang=js&"
export * from "./PlusDisplayLayer.vue?vue&type=script&lang=js&"
import style0 from "./PlusDisplayLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports